export const getEditableColumnFormItemName = (name: string, fieldName: string, index: number, isAddNew?: boolean) => {
  return `${name}.${isAddNew ? index - 1 : index}.${fieldName}`
}
